export const getFriaSectionState = ({
    friaRequired,
    hasFriaAssessment,
    friaStatus
}) => {
    if (!friaRequired && !hasFriaAssessment) {
        return {
            active: false,
            messageKey: "FRIA will become available once the AI Risk Assessment determines that a FRIA is required.",
            tooltipKey: "Based on the current AI Risk Assessment results, a Fundamental Rights Impact Assessment (FRIA) is not required for this asset."
        };
    }

    if (
        friaRequired &&
        !hasFriaAssessment &&
        friaStatus === "NOT_AVAILABLE"
    ) {
        return {
            active: false,
            messageKey: "The FRIA questionnaire has not been configured for your organization.",
            tooltipKey: "The FRIA questionnaire has not been configured for your organization."
        };
    }

    if (
        friaRequired &&
        !hasFriaAssessment &&
        friaStatus === "NOT_CREATED"
    ) {
        return {
            active: false,
            messageKey: "A FRIA assessment is required for this asset but has not been started yet.",
            tooltipKey: "A FRIA assessment is required for this asset but has not been started yet."
        };
    }

    return {
        active: true
    };
};
